<template>
  <div>
    <vue-c3 :handler="handler"></vue-c3>
  </div>
</template>
<script>

import Vue from 'vue';
import VueC3 from 'vue-c3';
require('c3/c3.css');

export default {
  name: 'MacroAverageChart',
  components: {
    VueC3
  },
  props: {
    protein: {
      handler: function () {
        this.draw();
      }
    },
    fat: {
      handler: function () {
        this.draw();
      }
    },
    carbs: {
      handler: function () {
        this.draw();
      }
    },
    kcals: {
      handler: function () {
        this.draw();
      }
    }
  },
  data () {
    return {
      handler: new Vue(),
      colors: [
        '#9765E0',
        '#00C2BA',
        '#C4CC52',
        '#F35647'
      ],
      names: {}
    };
  },
  watch: {
    protein: {
      handler: function () {
        this.draw();
      }
    },
    fat: {
      handler: function () {
        this.draw();
      }
    },
    carbs: {
      handler: function () {
        this.draw();
      }
    },
    kcals: {
      handler: function () {
        this.draw();
      }
    }
  },
  mounted () {
    this.draw();
  },
  methods: {
    draw () {
      const options = {
        data: {
          columns: [
            ['protein', this.protein, null, null, null],
            ['fat', null, this.fat, null, null],
            ['carbs', null, null, this.carbs, null],
            ['kcals', null, null, null, this.kcals]
          ],
          names: {
            protein: this.$t('health.summary.protein'),
            fat: this.$t('health.summary.fat'),
            carbs: this.$t('health.summary.carbs'),
            kcals: this.$t('health.summary.calories')
          },
          axes: {
            'protein': 'y',
            'fat': 'y',
            'carbs': 'y',
            'kcals': 'y2'
          },
          type: 'bar',
          labels: true
        },
        bar: {
          width: 20
        },
        color: {
          pattern: this.colors
        },
        axis: {
          x: {
            type: 'categorized',
            tick: {
              format: function (x) { return ''; }
            },
            padding: {top: 200, bottom: 0}
          },
          y: {
            label: {
              text: this.$t('health.summary.grams'),
              position: 'outer-middle'
            }
          },
          y2: {
            show: true,
            label: {
              text: this.$t('health.summary.kcals'),
              position: 'outer-middle'
            }
          }
        },
        tooltip: {
          show: false
        }
      };
      this.handler.$emit('init', options);
    }
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/brand/health/components/summary/MacroAverageChart.vue